import gql from "graphql-tag";

export const REPORT_PRINT_PDF_QUERY = gql`
  query PrintReport(
    $reportSecret: String!
    $language: CharacteristicLanguage!
    $sheetIds: [String!]
    $layout: PdfLayout!
    $settings: PrintPdfSettingsInput!
  ) {
    printReport(
      reportSecret: $reportSecret
      language: $language
      sheetIds: $sheetIds
      layout: $layout
      settings: $settings
    ) {
      base64
    }
  }
`;
